<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td
      v-for="filter in updatedFilters"
      :key="filter.field"
      class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
    >
      <v-text-field
        v-if="filter.type === 'text'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        type="text"
        @keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData(filter.field)"
      />
      
      <v-menu
        v-else-if="filter.type === 'date'"
        v-model="filter.menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :label="filter.label"
            v-model="filter.formatted"
            v-bind="attrs"
            @blur="updateDateValue(filter.field, filter.formatted)"
            v-on="on"
            hide-details="true"
            dense
            clearable
            @click:clear="clearFilterData(filter.field)"
          />
        </template>
        <v-date-picker
          v-model="searchData[filter.field]"
          no-title
          scrollable
          :max="today"
          @input="closeMenu(filter.field)"
        >
        <v-spacer />
          <v-btn text color="primary" @click="closeMenu(filter.field)">Cancel</v-btn>
        </v-date-picker>
      </v-menu>

      <v-select
        v-else-if="filter.type === 'select'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        :items="filter.items"
        item-text="role"
        item-value="role"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
      
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
import { formatDate, parseDate, date } from '../../../../lib/helpers';

export default {
  props: ['search', 'options'],
  data() {
    return {
      filters: [
        { label: 'Username', field: 'username', type: 'text' },
        { label: 'Role', field: 'role', type: 'select', items: [] },
        { label: 'Created At', field: 'created_at', type: 'date', menu: false, formatted: '' },
      ],
    };
  },
  computed: {
    today() {
      return new Date().toLocaleDateString('sv-SE');
    },
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    itemsRole() {
      return this.$store.state.rbac.role.allActiveRole;
    },
    updatedFilters() {
      return this.filters.map(filter => {
        if (filter.field === 'role') {
          return { ...filter, items: this.itemsRole };
        }
        return filter;
      });
    },
  },
  watch: {
    'searchData.created_at': {
      handler(newVal) {
        const dateFilter = this.filters.find(f => f.field === 'created_at');
        if (dateFilter) {
          dateFilter.formatted = formatDate(newVal);
        }
        this.getData();
      },
    },
  },
  async mounted() {
    this.getRoles();
  },
  beforeDestroy() {
    this.resetFilters();
  },
  methods: {
    resetFilters() {
      Object.keys(this.searchData).forEach(key => {
        this.searchData[key] = '';
      });
      this.getData();
    },
    getRoles() {
      this.$store.dispatch('rbac/role/fetchActiveRoles', {
        date,
      });
    },
    clearFilterData(field) {
      this.searchData[field] = '';
      this.getData();
    },
    updateDateValue(field, formattedValue) {
      const parsedDate = parseDate(formattedValue);
      if (parsedDate) {
        this.searchData[field] = parsedDate;
      }
    },
    closeMenu(field) {
      const dateFilter = this.filters.find(f => f.field === field);
      if (dateFilter) {
        this.$set(dateFilter, 'menu', false);
      }
    },
    getData() {
      const newOptions = { ...this.options, page: 1 };
      this.$emit('update:options', newOptions);
      this.$emit('getDataParent');
    },
  },
};
</script>